import { Box, Typography } from "@mui/material";
import React, { forwardRef, useEffect, useState } from "react";
import getLocation from "../../../helper/WorkshopLocation";
import sails from "../../../images/Sails.png";
import { DateTime } from "luxon";
import "./PrintRegistrationList.module.css";

const PrintRegistrationList = forwardRef(({ workshop }, ref) => {
  const [registrations, setRegistrations] = useState([]);

  useEffect(() => {
    if (workshop) {
      let regs = [...workshop?.registrations];

      setRegistrations(
        regs.sort((a, b) => {
          if (a?.staff.legalFirstname > b?.staff.legalFirstname) return 1;
          if (a?.staff.legalFirstname < b?.staff.legalFirstname) return -1;
          return 0;
        })
      );
    }
  }, [workshop]);

  //TODO: figure out how to format for new pages when printed

  return (
    <>
      {workshop && (
        <Box sx={{ margin: "0 3rem" }}>
          <Box sx={{ display: "flex", marginBottom: "1rem" }}>
            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}
            >
              <Typography variant="h3">{workshop?.title}</Typography>
              <Typography variant="body1">
                {DateTime.fromISO(workshop?.startDatetime).toLocaleString(
                  DateTime.DATETIME_SHORT
                )}
              </Typography>
              <Typography variant="body1">{getLocation(workshop)}</Typography>
            </Box>
            <Box sx={{ marginLeft: "auto" }}>
              <img style={{ width: "5rem" }} src={sails} />
            </Box>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            {registrations.map((reg, index) => (
              <Box
                key={index}
                sx={{
                  margin: "0.2rem",
                  breakInside: "avoid",
                  pageBreakInside: "avoid",
                  display: "flex",
                  gap: "1rem",
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                  }}
                >
                  <Typography variant="h4">{index + 1}</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box>
                    <Typography variant="h5">
                      {reg.staff.displayName}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="body2">
                      {reg.staff.jobTitle}
                    </Typography>
                    <Typography variant="body2">
                      {reg.staff.department}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    margin: "0 2rem",
                    borderBottom: "1px dashed darkgrey",
                    flexGrow: "1",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <Typography variant="h4" color="gray">
                    X
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
});

export default PrintRegistrationList;
